<template>
  <div class="panel-body">
    <div class="left">
      <div class="mr-t-10">
        <p class="discription">新規商品登録時（Amazonから追加画面）に既定で表示される受取金額の掛率を変更できます。</p>
        <p class="discription">Amazon価格に対する掛率を入力して下さい。</p>
        <p class="discription">※すでに登録済みの受取金額には影響しません。</p>
        <div class="row example">
          <span>例）受取金額掛率：90%  の場合</span>
          <p class="example-rate">Amazon価格：1000円<span class="example-arrow">-></span>受取金額(税込)：900円</p>
        </div>
        <form data-vv-scope="setting-form">
          <div class="form-group flexbox">
            <label class="control-label flex-item flex-lable flexbox justify-between label-width-3">受取金額掛率
              <span class="text-danger m-r-sm">＊</span>
            </label>
            <div class="flex-item flex-input">
              <input
                class="offer-rate-form form-control text-right"
                type="text"
                v-model.number="offerPriceRate"
                v-validate="'required|numeric|min_value:1|max_value:1000'"
                data-vv-as="受取金額倍率"
                data-vv-name="offerPriceRate"
                data-vv-scope="setting-form"
              >%
            </div>
            <p style="display: block" v-show="errors.has('setting-form.offerPriceRate')" class="text-danger">※{{ errors.first('setting-form.offerPriceRate') }}</p>
          </div>
          <div class="mr-t-20">
            <button class="btn btn-warning w-120" @click.prevent="updateSetting()" :disabled="disabled">
              更新
              <i class="fa fa-check text-size-16" aria-hidden="true"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Const from '@/common/msg'
import SettingService from '@/services/settingservice'
import Big from 'big.js'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      disabled: true,
      err: null,
      loader: null,
      oldOfferPriceRate: null
    }
  },
  created () {
    this.oldOfferPriceRate = this.userInfo.offerPriceRate
  },
  mounted () {
    this.checkDisabledButton()
    if (this.currentTab && this.currentTab === 'others') {
      let logParams = {
        name: eventCode.settings.other_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  },
  methods: {
    /*
     * Call API to update seller information
     *
     * @return void
     */
    async updateSetting () {
      let logParams = {}
      logParams = {
        name: eventCode.warehouses.click_update_received_amount_setting_button,
        properties: {
          oldOfferPriceRate: this.oldOfferPriceRate,
          newOfferPriceRate: this.userInfo.offerPriceRate
        }
      }

      EventService.postTrackLog(logParams)

      let result = await this.$validator.validateAll()
      if (result) {
        this.loader = this.$loading.show()
        const payload = {
          record: {
            offerPriceRate: this.userInfo.offerPriceRate
          }
        }
        SettingService.updateSetting(payload)
          .then((response) => {
            this.$store.commit('toggleModal', {
              show: true,
              message: Const.updateSuccess
            })
            this.oldOfferPriceRate = this.userInfo.offerPriceRate
          })
          .catch((err) => {
            this.$store.commit('toggleModal', {
              show: true,
              message: err
            })
            this.err = err
          })
          .finally(() => {
            this.loader && this.loader.hide()
          })
      }
    },
    /*
     * Check disabled submit button
     *
     * @return void
     *
     */
    async checkDisabledButton () {
      let result = await this.$validator.validate(null, null, { silent: true })
      this.disabled = !result
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    }),
    offerPriceRate: {
      get: function () {
        if (this.userInfo.offerPriceRate === null) return 90

        return new Big(this.userInfo.offerPriceRate).times(100).toNumber()
      },
      set: function (newValue) {
        if (Number.isInteger(newValue)) {
          this.userInfo.offerPriceRate = new Big(newValue).div(100).toNumber()
        } else {
          this.userInfo.offerPriceRate = 0
        }
      }
    }
  },
  watch: {
    userInfo: {
      handler () {
        this.checkDisabledButton()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.discription {
  margin-bottom: 0;
}
.example {
  margin: 18px 0;
}
.example-rate {
  margin-left: 26px;
}
.example-arrow {
  margin: 0 32px;
}
.offer-rate-form {
  width: 80px !important;
  display: inline-flex;
  margin-right: 8px;
}
.noti-setting-discription {
  margin-bottom: 20px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAmazon/ReceiveAmountSetting.vue